import React from 'react'
import { ICellRendererParams } from 'ag-grid-enterprise'
import DimensionName from '../../../../../features/dimension/components/DimensionName'
import { DropdownCellLayout } from './CellComponents'

export const DimensionTreeSelectRenderer: React.FC<ICellRendererParams> = ({ value }) => (
  <DropdownCellLayout>
    {value != null && value !== '' ? <DimensionName dimensionId={value} /> : null}
  </DropdownCellLayout>
)
